import React, { useState } from 'react';
import Close from '../../../../../Assets/Modals/closeIcon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal } from '../../../../../Features/dropTrackProductsSlice';
import { showToast } from '../../../../../Components/Toaster/Toaster';

function SelectCoupon({ selectCoupon }) {
    const dispatch = useDispatch();

    const coupons = useSelector((state) => state.dropTrackAction.couponsList);

    const [selectedCoupon, setSelectedCoupon] = useState({});

    const handleCloseButtonClick = () => {
        dispatch(closeModal());
    };

    const handleRadioSelection = (coupon) => {
        setSelectedCoupon(coupon);
    }

    const handleNextClick = () => {
        if(selectedCoupon) {
            selectCoupon(selectedCoupon);
        }
        else {
            showToast('Select coupon before proceeding', 'warning');
        }
    }

    return (
        <div className='flex flex-col gap-[10px] max-h-[55vh]'>
            <div className="flex items-center justify-between">
                <h1 className='font-urbanist-regular font-semibold text-2xl text-[#121212]'>Reactivate Existing Coupons</h1>

                <button onClick={handleCloseButtonClick}>
                    <img src={Close} alt="Close Modal" />
                </button>
            </div>

            <div className="flex flex-col gap-2 max-h-full overflow-y-scroll">
                {
                    coupons.length > 0 ? 
                    (
                        <>
                            {coupons?.map(coupon => {
                                return (
                                    <label key={coupon.id} className="m-0 flex items-center gap-2 cursor-pointer" htmlFor={coupon.couponName}>
                                        <input 
                                            value={coupon.couponName} 
                                            type="radio" 
                                            name={coupon.couponName} 
                                            id={coupon.couponName} 
                                            checked={selectedCoupon.couponName === coupon.couponName} 
                                            onChange={() => handleRadioSelection(coupon)} 
                                            className='hidden' 
                                        />

                                        <div className={`w-4 h-4 flex items-center justify-center rounded-full border ${selectedCoupon.couponName === coupon.couponName ? 'border-primaryColor' : 'border-[#757575]'}`}>
                                            {selectedCoupon.couponName === coupon.couponName && <div className="w-2 h-2 rounded-full bg-primaryColor"></div>}
                                        </div>
                                        {coupon.couponName}
                                    </label>
                                );
                            })}
                        </>
                    ) : 
                    <p className='italic text-[14px] leading-[22px] text-[#666666]'>There are no inactive coupons</p>
                }
            </div>

            <button onClick={handleNextClick} className={`px-4 py-2 rounded font-urbanist-regular font-semibold text-base text-center text-buttonText ${Object.keys(selectedCoupon).length !== 0 ? 'bg-primaryColor hover:bg-primaryAccent' : 'bg-buttonDisabledBg cursor-not-allowed'}`} type='button'>
                Next
            </button>
        </div>
    );
}

export default SelectCoupon;
